import { FloatingSidebarFooter } from './styled';
export function Footer(props) {
    const { children } = props;
    return <FloatingSidebarFooter>{children}</FloatingSidebarFooter>;
}
